import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import GramaticaForm from './GramaticaFormComponent';
import { putGramaticaFuerte, putGramaticaDebil } from '../../routing/routes';

const EditGramatica = ({ gramaticas, nodos, notify, refreshData, archivos, functionesChatbot, type }) => {
	const { id } = useParams();
	const history = useHistory();
	const gramatica =
		type === 'fuerte'
			? gramaticas.fuertes.find((gramatica) => gramatica._id === id)
			: gramaticas.debiles.find((gramatica) => gramatica._id === id);
	if (!gramatica) return <h3 style={{ textAlign: 'center' }}>Loading...</h3>;
	return (
		<GramaticaForm
			gramatica={gramatica}
			type={type}
			archivos={archivos}
			guardaGramatica={save}
			nodos={nodos}
			functionesChatbot={functionesChatbot}
		/>
	);

	function save(gramatica) {
		const data = { gramatica: gramatica };
		if (type === 'fuerte') {
			putGramaticaFuerte(data).then(() => {
				notify('mGramatica actualizada');
				history.push('/gramaticas');
				setTimeout(refreshData, 100);
			});
		} else {
			putGramaticaDebil(data).then(() => {
				notify('mGramatica actualizada');
				history.push('/gramaticas');
				setTimeout(refreshData, 100);
			});
		}
	}
};

export default EditGramatica;
